module.exports = __webpack_public_path__ + "static/img/cjfw-companyProducts2.98491e51.png";